import Image from "@/components/Image/image";

import styles from "./card-link.module.scss";
import classnames from "classnames";
import { CardLinkStoryblok } from "@/types/component-types-sb";
import { ArrowRightIcon } from "@phosphor-icons/react";
import Link from "../Link";

interface Props {
  blok: CardLinkStoryblok;
}

const CardLink = (props: Props) => {
  return (
    <Link href={props.blok.link || ""}>
      <div
        className={classnames(styles.baseWrapper, {
          [styles.wrapperInverse]: props.blok.invert_color,
          [styles.wrapper]: !props.blok.invert_color,
        })}
      >
        {props.blok.image && (
          <div>
            <Image
              className={styles.img}
              filename={props.blok.image.filename}
              alt={props.blok.image.alt}
              focus={props.blok.image.focus}
              aspectMobile={"1/1"}
              priority
            />
          </div>
        )}
        <div className={styles.textContentWrapper}>
          <div className={classnames(styles.header, styles.mt16)}>
            {props.blok.title}
          </div>
          <div className={classnames(styles.mt4, "ef-text-para -light -small")}>
            {props.blok.description}
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <span className="mr-2">More info</span>{" "}
              <ArrowRightIcon size={18} weight="bold" aria-hidden="true" />
            </div>
          </div>
        </div>
        {props.blok.badgeText && (
          <div className={styles.badge}>{props.blok.badgeText}</div>
        )}
      </div>
    </Link>
  );
};

export default CardLink;
